export var getVideoTextTrackId = function getVideoTextTrackId(kind, lang) {
  return "".concat(kind, "-").concat(lang);
};